module.exports = __webpack_public_path__ + "static/ice-cream-99d17575d28300fa0db2a35627906291.svg";